import React from 'react';
import { motion } from 'framer-motion';
export function PullQuote() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="w-full max-w-2xl mx-auto my-16 px-4 text-center relative" data-id="element-137">
      <span className="absolute -top-12 left-1/2 -translate-x-1/2 text-8xl font-serif text-brown-light/20 leading-none" data-id="element-138">
        "
      </span>
      <p className="font-serif text-2xl md:text-3xl italic text-brown-dark relative z-10 leading-relaxed" data-id="element-139">
        Wenn man verzweifelt ist, greift man nach jedem Strohhalm.
      </p>
    </motion.div>;
}